module.exports = __webpack_public_path__ + "static/media/loading.dbb79eae.gif";